var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.965766 11.849L0.960899 11.84C0.330408 10.6697 0 9.35391 0 8.02559C0 3.59845 3.58697 0 8 0C12.413 0 16 3.59844 16 8.02555C16 9.35323 15.6699 10.6689 15.0411 11.8367L15.0361 11.846L10.1878 20.6424C9.74652 21.4431 8.90744 21.9366 8 21.9366C7.09254 21.9366 6.25346 21.4431 5.81222 20.6423L5.81174 20.6414L0.965766 11.849ZM7.67918 19.6067C7.74363 19.7239 7.86645 19.7964 8 19.7964C8.13355 19.7964 8.25637 19.7239 8.32082 19.6067L8.46671 19.3421L9.46088 17.5383L13.1641 10.8196C13.6239 9.96571 13.8667 8.99975 13.8667 8.02555C13.8667 4.78042 11.2348 2.14016 8 2.14016C4.76518 2.14016 2.13333 4.78042 2.13333 8.02559C2.13333 8.99979 2.37612 9.9657 2.83768 10.8224L6.5156 17.4956L7.52394 19.3251L7.67918 19.6067Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5982 21.7052C12.5982 22.0215 12.3967 22.572 11.5215 23.1365C10.6666 23.6878 9.37074 24.0912 7.84144 24.0912C6.31214 24.0912 5.01627 23.6878 4.16139 23.1365C3.28617 22.572 3.08468 22.0215 3.08468 21.7052C3.08468 21.3889 3.28617 20.8384 4.16139 20.274C4.95646 19.7612 6.13296 19.3764 7.52394 19.3251L6.5156 17.4956C3.47289 17.892 1.18198 19.6261 1.18198 21.7052C1.18198 24.0772 4.16352 26 7.84144 26C11.5194 26 14.5009 24.0772 14.5009 21.7052C14.5009 19.6935 12.3562 18.0048 9.46088 17.5383L8.46671 19.3421C9.7234 19.4346 10.7858 19.7995 11.5215 20.274C12.3967 20.8384 12.5982 21.3889 12.5982 21.7052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStations);
export default __webpack_public_path__ + "static/media/Stations.3ad67e3cfb72c569037fdd6a9acb027d.svg";
export { ForwardRef as ReactComponent };